import { ColDef } from 'ag-grid-community';
import React, { useCallback, useRef, useState } from 'react';
import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { useBlockedStoragesColumns } from '../../hooks/useAgGridColumns';
import { BlockedStorage } from '../../models/EligibleStorage';

interface BlockedStoragesAgGridTableProps {
  blockedStorages: BlockedStorage[];
  className?: string;
  selectedColumns?: string[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: { field: string; direction: 'asc' | 'desc' } | null;
  onSortingChange?: (
    sorting: { field: string; direction: 'asc' | 'desc' } | null
  ) => void;
  onUnblockStorage?: (blockId: number) => void;
}

export const BlockedStoragesAgGridTable = React.memo(
  function BlockedStoragesAgGridTable({
    blockedStorages,
    selectedColumns = [],
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    sorting,
    onSortingChange,
    onUnblockStorage,
  }: BlockedStoragesAgGridTableProps) {
    const agGridRef = useRef<AgGridTableRef>(null);

    const { filteredColumnDefs } = useBlockedStoragesColumns({
      selectedColumns,
      onUnblockStorage,
    });

    return (
      <div className="w-full">
        <AgGridTable
          ref={agGridRef}
          data={blockedStorages}
          columnDefs={filteredColumnDefs as ColDef[]}
          height="calc(100vh - 200px)"
          enableSelection={false}
          onGridReady={() => undefined}
          className="rounded-lg shadow-sm"
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          gridOptions={{}}
          sorting={sorting}
          onSortingChange={onSortingChange}
          rowHeight={50}
        />
      </div>
    );
  }
);

